import { Formik } from 'formik';
import React from 'react';
import {
  Container,
  Divider,
  Form,
  Header,
  Button,
  Message,
} from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { Provider } from 'types/provider';
import { request } from 'utils/api';
import styles from './Settings.module.css';
import CheckboxField from 'components/form-fields/formik/CheckboxField';

const SettingsPayments: React.FC<{
  provider: Partial<Provider>;
}> = ({ provider }) => {
  const { t } = useTranslation();
  return (
    <Container>
      <Header as="h2" style={{ padding: '0', margin: '0' }}>
        {t('editSandboxPayments.title', 'Payments')}
      </Header>
      <Divider />
      <p>{t('editSandboxPayments.description', 'Payments settings')}</p>
      <Formik
        enableReinitialize
        initialValues={{
          enablePayAsYouCharge: provider.enablePayAsYouCharge,
          enablePSPIntegrations: provider.enablePSPIntegrations,
          enablePSPIntegrationsV2: provider.enablePSPIntegrationsV2,
        }}
        onSubmit={(values) => {
          request({
            method: 'PATCH',
            path: `/1/sandboxes/${(provider as any)._id}/settings`,
            body: {
              ...provider,
              ...values,
            },
          });
        }}>
        {({ handleSubmit, isSubmitting, isValid, dirty }) => {
          return (
            <Form>
              <Form.Field className={styles.productProposition}>
                <CheckboxField
                  toggle
                  label={t(
                    'editSandboxPayments.enablePayAsYouCharge',
                    'Enable Pay As You Charge'
                  )}
                  name="enablePayAsYouCharge"
                />
                <Message info>
                  {t(
                    'editSandboxPayments.enablePayAsYouChargeInfo',
                    'Enables real-time payment processing during charging sessions, allowing users to pay incrementally as they charge.'
                  )}
                </Message>
              </Form.Field>
              <Form.Field className={styles.productProposition}>
                <CheckboxField
                  toggle
                  label={t(
                    'editSandboxPayments.enablePSPIntegration2',
                    'Enable Payment Processing via PSP (BETA)'
                  )}
                  name="enablePSPIntegrationsV2"
                />
                <Message info>
                  {t(
                    'editSandboxPayments.enablePSPIntegration2Info',
                    'Beta version of enhanced PSP integration with improved security, performance, and additional payment method support.'
                  )}
                </Message>
              </Form.Field>
              <Form.Field className={styles.productProposition}>
                <CheckboxField
                  toggle
                  label={t(
                    'editSandboxPayments.enablePSPIntegrationsV1',
                    'Enable integration of payment through Payment Service Providers (mobile).'
                  )}
                  name="enablePSPIntegrations"
                />
                <Message info>
                  {t(
                    'editSandboxPayments.enablePSPIntegrationsV1Info',
                    'Integrates mobile payment processing through Payment Service Providers for seamless in-app transactions.'
                  )}
                </Message>
              </Form.Field>
              <Button
                disabled={isSubmitting || !isValid}
                onClick={() => handleSubmit()}
                primary>
                {t('save', 'Save')}
              </Button>
            </Form>
          );
        }}
      </Formik>
    </Container>
  );
};

export default SettingsPayments;
